import NameGenerator from './NameGenerator/NameGenerator';
import Footer from './Footer/Footer';

function App() {
  return (
    <>
      <NameGenerator />
      <Footer />
    </>
  );
}

export default App;
